import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  TableHead,
  TableSortLabel,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Stack,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Close as CloseIcon,
  PersonAdd as PersonAddIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Layout from "./layout";
import InputAdornment from "@mui/material/InputAdornment";
import Divider from "@mui/material/Divider"; // Import Divider
import axios from "axios";
import "../App.css";
import { useAcademicYear } from "./AcademicYearContext";

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${TableCell.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
    fontSize: 15,
  },
  [`&.${TableCell.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // Hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// EnhancedTableHead Component
function EnhancedTableHead(props) {
  const { order, orderBy, handleRequestSort } = props;
  const createSortHandler = (property) => () => {
    handleRequestSort(property);
  };

  const headCells = [
    {
      id: "fees_slab_id",
      numeric: false,
      disablePadding: false,
      label: "Fees Slab ID",
    },
    {
      id: "fees_slab",
      numeric: false,
      disablePadding: false,
      label: "Fees Slab",
    },
    {
      id: "",
      numeric: false,
      disablePadding: false,
      label: "",
    },
  ];

  return (
    <TableHead>
      <TableRow
        style={{
          backgroundColor: "#0A64A2",
          color: "#fff",
          textAlign: "center",
          height: "40px",
        }}
      >
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            style={{ textAlign: "center", color: "#fff" }}
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
          >
            {headCell.id !== "" ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  handleRequestSort: PropTypes.func.isRequired,
};

// Main EnhancedTable Component
export default function EnhancedTable() {
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("fees_slab_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [feesSlab, setFeesSlab] = useState([]);
  const [feesSlabName, setFeesSlabName] = useState("");
  const [feesSlabId, setFeesSlabId] = useState(0);
  const [feesSlabNameError, setFeesSlabNameError] = useState(false);
  const [feesSlabLabel, setFeesSlabLabel] = useState("Enter Fees Slab");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [search, setSearch] = useState("");
  const [feesSlabModal, setFeesSlabModal] = useState(false);
  const [userId, setUserId] =useState();
  // const [academicYearId, setAcademicYearId] = useState(0);

  const { academicYearId } = useAcademicYear();

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);
  useEffect(() => {
    const fetchUserData = async () => {
     
        const email = localStorage.getItem('user_email');
        try {
      const response = await axios.post(
            `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`, 
            { email },
            { headers: { 'user_email': email }},
          );
      
          if (response.status === 200) {
            setUserId(response.data.user.user_id);
            console.log("response", response.data.user.user_id);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchUserData();
    }, []);

   ;
  

  const navigate = useNavigate();

  // Fetch Fees Slab Data
  useEffect(() => {
    getFeeSlab();
  }, []);

  useEffect(() => {
    console.log(process.env.REACT_APP_JHS_DEVELOPMENT);
    getFeeSlab();
  }, []);

  const openAddFeesSlabModal = (event) => {
    setFeesSlabModal(true);
  };

  const handleOpenDeleteDialog = (feesSlabId) => {
    setOpenDeleteDialog(true);
    setFeesSlabId(feesSlabId);
  };

  const closeAndDeleteDialog = () => {
    setOpenDeleteDialog(false);
    handleDelete();
  };

  const closeDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleClose = () => {
    setFeesSlabModal(false);
    setFeesSlabName("");
    setFeesSlabLabel("Enter Fees Slab");
    setFeesSlabId(0);
    setFeesSlabNameError(false);
  };


  const getFeeSlab = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/getFeeSlab", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: 'include',
      body: JSON.stringify({
        academic_year_id: academicYearId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect if unauthorized
          return;
        }
        return response.json();
      })
      .then((response) => {
        if (response) setFeesSlab(response);
      })
      .catch((error) => console.error("Error fetching fees slab:", error));
  };
  
  const saveFeeSlab = async () => {
    if (feesSlabName === "") {
      // feesSlabNameError = "Fees Slab Required"
      setFeesSlabNameError("Fees Slab Required");
      // setFeesSlabLabel("*Fees Slab Required");
      return;
    }

    const payload = {
      fees_slab: feesSlabName,
      // grade_id: 1,
      academic_year_id: academicYearId,
      created_timestamp: new Date(),
      // updated_timestamp: "2024-01-01 05:30:00+05:30",
      created_by: userId,
      // updated_by: "admin",
    };

    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/saveFeeSlab", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: 'include',
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect if unauthorized
          return;
        }
        return response.json();
      })
      .then((response) => {
        if (response) handleResponse(response);
      })
      .catch((error) => console.error("Error saving fees slab:", error));
  };

  const editFeeSlab = async () => {
    if (feesSlabName === "") {
      setFeesSlabNameError(true);
      setFeesSlabLabel("*Fees Slab Required");
      return;
    }

    const payload = {
      fees_slab_id: feesSlabId,
      fees_slab: feesSlabName,
      grade_id: 1,
      academic_year_id: academicYearId,
      // created_timestamp: "2024-01-01 05:30:00+05:30",
      updated_timestamp: new Date(),
      // created_by: "admin",
      updated_by: userId,
    };

    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/editFeeSlab", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: 'include',
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect if unauthorized
          return;
        }
        return response.json();
      })
      .then((response) => {
        if (response) handleResponse(response);
      })
    
      .catch((error) => console.error("Error editing fees slab:", error));
  };


  const deleteFeeSlab = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/deleteFeeSlab", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        feesSlabIds: [feesSlabId],
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect if unauthorized
          return;
        }
        return response.json();
      })
      .then((response) => {
        if (response) handleResponse(response);
      })
      .catch((error) => console.error("Error deleting fees slab:", error));
  };
  
  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      setSnackbar({
        open: true,
        message: responseObject.message,
        severity: "success",
      });
      reset();
      getFeeSlab();
      handleClose();
    } else {
      // Show error snackbar
      setSnackbar({
        open: true,
        message: responseObject.error || "Something went wrong!",
        severity: "error",
      });
    }
  };

  const reset = () => {
    setFeesSlabId("");
    setFeesSlabName("");
    setFeesSlabLabel("Enter Fees Slab");
    setFeesSlabNameError(false);
  };

  const handleEdit = (feesSlabName, feesSlabId) => {
    setFeesSlabModal(true);
    setFeesSlabId(feesSlabId);
    setFeesSlabName(feesSlabName);
    setFeesSlabLabel("Edit Fees Slab");
  };

  const handleDelete = () => {
    deleteFeeSlab();
    handleClose();
  };

  //Arohi
  //Added Sorting and Pagination
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  // Filter and Sort Data
  const filteredAndSortedData = useMemo(() => {
    let data = feesSlab;

    // Apply Search Filter
    if (search) {
      data = data.filter(
        (fs) =>{
          const searchTerms = search.toLowerCase().split(" ").filter(Boolean); // Split on spaces and remove empty strings
  return searchTerms.every((term)=> 
    fs.fees_slab_id .toString() .toLowerCase() .includes(term) ||
  fs.fees_slab.toString() .toLowerCase() .includes(term)
  )
        
         
        }
      );
    }

  
    // Apply Sorting to the filtered data
    data = stableSort(data, getComparator(order, orderBy));

    return data;
  }, [feesSlab, order, orderBy, search]);

  // Paginate Data after sorting
  const paginatedData = useMemo(() => {
    return filteredAndSortedData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [filteredAndSortedData, page, rowsPerPage]);

  // Handle Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div style={{ padding: 20, backgroundColor: "white" }}>
      <Layout />

      <Dialog onClose={handleClose} open={feesSlabModal}>
        <DialogTitle
          alignSelf={"left"}
          style={{
            paddingBottom: "0",
            marginLeft: "9px",
            marginRight: "6px",
            color: "#0A64A2",
          }}
          // className="dialog_title"
        >
          {feesSlabId ? (
            <span style={{ fontSize: "1em" }}>
              {<PersonAddIcon />} Edit Fees Slab
            </span>
          ) : (
            <span style={{ fontSize: "1em" }}>
              {<PersonAddIcon />} Add Fees Slab
            </span>
          )}
          <Divider className="divider" />
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Stack spacing={4} padding={1}>
            <TextField
            required
              id="outlined-basic"
              error={feesSlabNameError}
              inputProps={{ maxLength: 10 }}
              value={feesSlabName}
              onChange={(event) => {
                setFeesSlabName(event.target.value);
              }}
              size="small"
              label={feesSlabNameError?feesSlabNameError:"Fees Slab Name"} // Ensure to set a proper label
              variant="outlined"
            />
            <div className="button-container">
              <Button className="save_update_btn"
                variant="contained"
                backgroundColor="#0A64A2"
                onClick={feesSlabId ? editFeeSlab : saveFeeSlab}
              >
                {feesSlabId ? <>Update</> : <>Save</>}
              </Button>
            </div>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={closeDeleteDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px",borderRadius:"5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Are you sure you want to delete this Fees Slab?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {" "}
          {/* Center-align the buttons */}
          <Button
          variant="contained"
            onClick={closeAndDeleteDialog}
            className="no-btn"
          >
            Yes
          </Button>
          <Button
          variant="contained"
            onClick={closeDeleteDialog}
            autoFocus
            className="no-btn"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Header and Actions */}

      <div>
        <h2 className="fees_management_title"> Fees Slab</h2>
      </div>
      <Stack spacing={2} direction="row" mb={2}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate("/fees-report")}
        >
          Fees
        </Button>
        <Button className="save_update_btn"
          variant="contained"
          color="primary"
          onClick={() => navigate("/fees-slab")}
        >
          Fees Slab
        </Button>
         <Button
                  variant="outlined"
                  onClick={() => {
                    navigate("/kit-payment-management");
                  }}
                >
                  Kit Payment
                </Button>
      </Stack>

      {/* Search Box */}
      <div style={{ marginBottom: "6px" }}>
        <Stack spacing={2} direction="row" mb={0} display={"flex"}>
          <Box
            component="form"
            sx={{ flexGrow: 1, width: "300px", display: "flex" }}
          >
            <TextField
              label="Search..."
              variant="outlined"
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
                setPage(0); // Reset to first page
                }}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      type="button"
                      sx={{ p: "10px" }}
                      aria-label="search"
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Button className="save_update_btn"
            variant="contained"
            color="primary"
            onClick={openAddFeesSlabModal}
          >
            Add Fees Slab
          </Button>
        </Stack>
      </div>

      {/* Fees Slab Table */}
      <Paper>
        <TableContainer>
          <Table
            aria-label="fees slab table"
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              handleRequestSort={handleRequestSort}
            />
            <TableBody>
              {paginatedData.map((row) => (
                <StyledTableRow
                  key={row.fees_slab_id}
                >
                  <StyledTableCell
                    align="center"
                  >
                    {row.fees_slab_id}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{paddingRight:'40px'}}
                  >
                    {row.fees_slab}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{ lineHeight: "10px", padding: "5px" }}
                  >
                    <IconButton
                      color="primary"
                      onClick={() =>
                        handleEdit(row.fees_slab, row.fees_slab_id)
                      }
                      style={{ height: "5px" }}
                    >
                      <EditIcon style={{height:'50px', color:'#0A64A2'}}/>
                    </IconButton>
                    <IconButton
                      color="black"
                      onClick={() => handleOpenDeleteDialog(row.fees_slab_id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={filteredAndSortedData.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
          labelRowsPerPage="Rows per page:"
          sx={{
            ".MuiTablePagination-toolbar": {
              backgroundColor: "#0A64A2",
              color: "white",
            },
            ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
              {
                color: "white",
              },
            ".MuiTablePagination-select": {
              color: "white",
            },
            ".MuiTablePagination-actions": {
              color: "white",
            },
          }}
        />
      </Paper>

      {/* Snackbar for Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}